// extracted by mini-css-extract-plugin
module.exports = {"story_desc":"StoryDescribe_story_desc__yZ8kM","story_mobiledesc":"StoryDescribe_story_mobiledesc__2vmoB"};